var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H10C10.7949 0.00232161 11.5566 0.319138 12.1188 0.881244C12.6809 1.44335 12.9977 2.20506 13 3V9H7C6.73478 9 6.48043 9.10536 6.29289 9.29289C6.10536 9.48043 6 9.73478 6 10C6 10.2652 6.10536 10.5196 6.29289 10.7071C6.48043 10.8946 6.73478 11 7 11H13V17C12.9977 17.7949 12.6809 18.5566 12.1188 19.1188C11.5566 19.6809 10.7949 19.9977 10 20H3C2.20506 19.9977 1.44335 19.6809 0.881245 19.1188C0.319138 18.5566 0.00232124 17.7949 0 17V3C0.00232124 2.20506 0.319138 1.44335 0.881245 0.881244C1.44335 0.319138 2.20506 0.00232161 3 0Z",
    fill: "#EC2124"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5913 9.0012L15.2913 7.7112C15.1042 7.52263 14.9995 7.26764 15.0001 7.00205C15.0006 6.73646 15.1064 6.4819 15.2942 6.29409C15.482 6.10629 15.7365 6.00054 16.0021 6C16.2677 5.99946 16.5227 6.10417 16.7113 6.2912L19.7113 9.2912C19.8964 9.48117 20 9.73594 20 10.0012C20 10.2665 19.8964 10.5212 19.7113 10.7112L16.7113 13.7112C16.5217 13.8971 16.2668 14.0012 16.0013 14.0012C15.7358 14.0012 15.4808 13.8971 15.2913 13.7112C15.1039 13.5224 14.9988 13.2672 14.9988 13.0012C14.9988 12.7352 15.1039 12.48 15.2913 12.2912L16.5913 11.0012H13.0013V9.0012H16.5913Z",
    fill: "#EC2124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/Out.7ff688cdbf9805e2faa0b31e2d5fe1a9.svg";
export { ForwardRef as ReactComponent };